export class BlockUIConfig {
  static getConfig() {
    return {
        message: 'Ładowanie',
        delayStart: 300
    }
  }
  static getHttpConfig(){
    return {
      requestFilters: [
        /^\/api\/userPrincipal/,
        /^\/api\/pinger\/ping/,
        /^\/api\/uczen\/pracedomowe\/\d+\/zadanie\/\d+\/wyswietlone/,
        /^\/api\/nauczyciel\/statystyki\/aktywnosc\/feed/,
        /^\/api\/admin\/aktywnosc\/feed/,
        /^\/api\/admin\/zadanie-wygenerowane\/zadania-pomocnicze\/liczba/,
        /^\/api\/konto\/problemy\/wiadomosci\/nieprzeczytane/,
        /^\/api\/helpdesk\/problemy/,
        /^\/api\/clickstream/,
        /^\/api\/ws\/.+/
      ]
    }
  }
}
